<style lang="scss" scoped>
.v-slide-group__prev.v-slide-group__prev--disabled {
  display: none !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s;
  max-height: 500px;
}
.fade-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-leave-to {
  transition: all 0.1s;
  opacity: 0;
  max-height: -200px;
}
</style>

<template>
  <div>
    <v-card color="white" outlined>
      <div style="max-width: 950px" class="mx-auto">
        <v-row>
          <v-col cols="12" sm="4">
            <v-sheet class="mt-2">
              <v-card flat>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Lisboa, PT</v-list-item-title>
                    <v-list-item-subtitle
                      >Wed, 9:15 AM, Mostry sunny</v-list-item-subtitle
                    >
                    <v-row>
                      <v-col cols="4" class="text-h4 font-weight-thin">
                        10&deg;C
                      </v-col>
                      <v-col>
                        <v-icon
                          style="margin-left: -15px"
                          class="mt-1"
                          size="30"
                          >mdi-cloud</v-icon
                        >
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-sheet>
          </v-col>

          <v-col cols="12" sm="4">
            <v-card-text>
              <v-sheet class="text-center mb-4">
                <!-- <v-avatar color="primary" size="80">
                  <v-icon size="50" dark>{{ leadType.icon }}</v-icon>
                </v-avatar> -->

                <v-progress-circular
                  :size="80"
                  :width="10"
                  style="margin-top: 0px;"
                  v-bind="score"
                >
                  <span v-if="lead.score" class="subtitle-1">{{
                    score.number
                  }}</span>
                  <span v-else><v-icon size="30">mdi-help</v-icon></span>
                </v-progress-circular>
              </v-sheet>
              <div class="mt-1">
                <h1 class="text-center">{{ lead.identifier_code }}</h1>
                <h3 class="text-center">{{ leadType.description }}</h3>

                  <v-sheet class="text-center mt-2">
                    <v-menu
                      v-if="lead.id"
                      top
                      close-on-click
                      max-height="500"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          small
                          :loading="loading_status"
                          elevation="0"
                          color="#f1f1f1"
                          :disabled="
                            !$store.getters['auth/getScope']('leads.update_status')
                          "
                        >
                          <v-icon
                            size="13"
                            class="mr-2"
                            :color="lead.status.color"
                            >mdi-circle</v-icon
                          >
                          {{
                            lead.status ? lead.status.name : "Sem status"
                          }}
                          <v-icon right small>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item
                          v-for="(item, index) in lead_statuses"
                          :key="index"
                          @click="changeLeadStatus(item)"
                          :input-value="item.id == lead.status.id"
                          color="primary"
                        >
                          <v-list-item-title>{{ item.name }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-sheet>
                <h3 class="text-center font-weight-light py-5">
                  {{ lead.claim_description }}
                </h3>
              </div>
            </v-card-text>
          </v-col>

          <v-col>
            <!-- <v-sheet class="text-right">
              <v-card flat>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Score</v-list-item-title>
                    <v-list-item-subtitle>Pontuação de confiabilidade</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-progress-circular
                  :size="60"
                  :width="7"
                  :value="19"
                  :rotate="90"
                  color="red"
                  style="margin-top: 0px;"
                >
                  <span class="subtitle-1">190</span>
                </v-progress-circular>
              </v-card>              
            </v-sheet> -->
          </v-col>
        </v-row>

        <ScopeProvider scope="leads.approve">
          <v-alert dense type="warning" v-if="lead.id && lead.approved == null">
            {{ $capitalize($tc("model.leads_lead_approval_message")) }}
            <template v-slot:append>
              <v-btn
                @click="confirmRefuseLead(lead)"
                color="red"
                small
                class="mr-1"
                >{{ $capitalize($tc("model.leads_refuse_lead_button")) }}</v-btn
              >
              <v-btn @click="acceptLead(lead)" color="green" small>{{
                $capitalize($tc("model.leads_accept_lead_button"))
              }}</v-btn>
            </template>
          </v-alert>
        </ScopeProvider>

        <v-divider></v-divider>

        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-toolbar flat>
          <v-tabs>
            <v-tab
              v-for="tab in primaryTabs"
              :key="tab.name"
              :to="{ name: tab.route }"
              :exact="tab.exact"
            >
              {{ tab.name }}
            </v-tab>
            <v-menu bottom left v-if="otherTabs.length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  class="align-self-center mr-4"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ $capitalize($tc("model.leads_more_button")) }}
                  <v-icon right> mdi-menu-down </v-icon>
                </v-btn>
              </template>

              <v-list class="grey lighten-3">
                <v-list-item
                  v-for="tab in otherTabs"
                  :key="tab.name"
                  :to="{ name: tab.route }"
                  :exact="tab.exact"
                >
                  {{ tab.name }}
                </v-list-item>
              </v-list>
            </v-menu>
          </v-tabs>
        </v-toolbar>
      </div>
    </v-card>

    <v-container style="max-width: 950px">
      <router-view></router-view>
    </v-container>

    <v-dialog v-model="confirmation_modal" max-width="600px">
      <v-card>
        <v-form @submit.prevent="refuseLead(confirmation_action)">
          <ValidationObserver ref="confirmation_modal" v-slot="{ invalid }">
            <v-card-title>
              {{ $capitalize($tc("model.leads_confirmation_modal")) }}
              <v-spacer></v-spacer>
              <v-btn @click="confirmation_modal = false" icon>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              {{ $capitalize($tc("model.leads_message_reprove_lead")) }}
              <ValidationProvider
                name="approve_justification"
                rules="required"
                v-slot="{ errors }"
              >
                <v-textarea
                  v-model="approve_justification"
                  name="approve_justification"
                  :label="$capitalize($tc('model.leads_label_justification'))"
                  filled
                  :error-messages="errors"
                ></v-textarea>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="confirmation_modal = false" text>{{
                $capitalize($tc("model.leads_cancel_button"))
              }}</v-btn>
              <v-btn type="submit" text color="red" :disabled="invalid">{{
                $capitalize($tc("model.leads_refuse_lead_button"))
              }}</v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { changeStatus, approveLead } from "../services/lead";
import ScopeProvider from "@/components/ScopeProvider";
import { lead_types } from "../services/lead_types";

export default {
  name: "lead_detail",
  components: { ScopeProvider },
  data: function() {
    return {
      tab: 0,
      tabs: [
        {
          name: this.$capitalize(this.$tc("model.leads_resume_detail")),
          route: "lead_detail_data",
          scope: "leads.read",
          exact: true
        },
        {
          name: this.$capitalize(this.$tc("model.leads_policy_detail")),
          route: "lead_detail_policy",
          scope: "leads.read"
        },
        {
          name: this.$capitalize(this.$tc("model.leads_schedulings_detail")),
          route: "lead_detail_scheduling_list",
          scope: "leads.schedulings.read"
        },
        {
          name: this.$capitalize(this.$tc("model.leads_damages_detail")),
          route: "damages",
          scope: "leads.damages.read"
        },
        {
          name: this.$capitalize(this.$tc("model.leads_comments_detail")),
          route: "lead_detail_comments",
          scope: "leads.comments.read"
        },
        {
          name: this.$capitalize(
            this.$tc("model.leads_document_management_detail")
          ),
          route: "lead_detail_files",
          scope: "leads.attachments.read"
        },
        {
          name: this.$capitalize(this.$tc("model.leads_integration_detail")),
          route: "integration",
          scope: "leads.integration.read"
        }
      ],
      menu: false,
      show_more_info: false,
      loading: false,
      loading_status: null,
      confirmation_modal: false,
      confirmation_action: null,
      approve_justification: ""
    };
  },
  methods: {
    ...mapActions("lead_statuses", ["loadStatuses"]),
    updateStatusHistory(value, options = {}) {
      this.$store.commit("setLead", {
        ...this.lead,
        status: value.status,
        ...options
      });

      this.$store.commit("setLeadStatusHistory", value.status_history);
    },
    async changeLeadStatus(status) {
      this.loading_status = true;
      try {
        const new_status = await changeStatus(this.lead.id, status.id);
        this.updateStatusHistory(new_status);
      } catch (error) {
        console.error(error);
        alert("error");
      } finally {
        this.loading_status = false;
      }
    },
    getServiceNumber() {
      return this.$route.params["lead_number"];
    },
    async getLead() {
      this.loading = true;
      try {
        const response = await this.$http.get(`/leads/${this.service_number}`);

        this.$store.commit("setLead", response.data);
      } catch (error) {
        this.$router.replace("/leads/ops");
      } finally {
        this.loading = false;
      }
    },
    getLeadNumber() {
      return this.service_number;
    },
    async acceptLead(lead) {
      this.$store.commit("setLoading", { loading: true });
      try {
        const response = await approveLead(lead.id, true);
        lead.approved = response.approved;

        this.$store.commit("sendMessage", {
          text: "Lead aprovada com sucesso"
        });

        this.updateStatusHistory(response, { approved: response.approved });
      } catch (error) {
      } finally {
        this.$store.commit("setLoading", { loading: false });
      }
    },
    async refuseLead(lead) {
      this.$store.commit("setLoading", { loading: true });
      try {
        const response = await approveLead(
          lead.id,
          false,
          this.approve_justification
        );
        lead.approved = response.approved;

        this.confirmation_modal = false;

        this.$store.commit("sendMessage", {
          text: "Lead recusada com sucesso"
        });

        this.updateStatusHistory(response, { approved: response.approved });
      } catch (error) {
        if (error.response.status == 422) {
          this.$refs.confirmation_modal.setErrors(error.response.data.errors);
          this.$store.commit("sendMessage", {
            text: error.response.data.message,
            color: "red"
          });
        } else {
          this.$store.commit("sendMessage", {
            text: "Falha ao reprovar lead",
            color: "red"
          });
        }
      } finally {
        this.$store.commit("setLoading", { loading: false });
      }
    },
    confirmRefuseLead(lead) {
      if (this.$refs.confirmation_modal) {
        this.$refs.confirmation_modal.reset();
      }

      this.approve_justification = "";
      this.confirmation_modal = true;
      this.confirmation_action = lead;
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    score: function() {
      const total = 1000;
      const number = this.lead.score || 1000;
      const percentage = (number / total) * 100;
      let color = "red";

      if (number >= 0 && number <= 400) {
        color = "red";
      }
      if (number >= 401 && number <= 700) {
        color = "orange";
      }
      if (number >= 701 && number <= 1000) {
        color = "green";
      }

      if (this.lead.score == null) {
        color = "grey";
      }

      return {
        color,
        number,
        value: percentage
      };
    },
    ...mapState("lead_statuses", ["lead_statuses"]),
    service_number: function() {
      return this.getServiceNumber();
    },
    lead: function() {
      return this.$store.getters.getLead;
    },
    leadType: function() {
      if (this.lead.lead_type?.id == lead_types.danos_por_agua)
        return {
          icon: "mdi-water",
          description: this.lead.lead_type?.description
        };

      if (this.lead.lead_type?.id == lead_types.riscos_eletricos)
        return {
          icon: "mdi-flash",
          description: this.lead.lead_type?.description
        };

      return {};
    },
    tree: function() {
      return [
        {
          id: 2,
          name: "Participantes",
          icon: "mdi-account-group",
          children: this.lead.participants.map(participant => {
            return {
              id: `02${participant.id}`,
              name: participant?.contact?.name,
              icon: "mdi-account",
              children: participant.services.map(service => ({
                id: `02${participant.id}${service.id}`,
                name: service.service_number,
                icon: "mdi-wrench",
                to: "/leads"
              }))
            };
          })
        },
        {
          id: 3,
          name: "Serviços",
          icon: "mdi-toolbox",
          children: this.lead.services.map(service => ({
            id: `03${service.id}`,
            name: service.service_number,
            icon: "mdi-wrench"
          }))
        }
      ];
    },
    allowedTabs: function() {
      return this.tabs.filter(tab =>
        this.$store.getters["auth/getScope"](tab.scope)
      );
    },
    tabsLength: function() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
        case "sm":
          return 2;
        default:
          return 4;
      }
    },
    primaryTabs: function() {
      return this.allowedTabs.slice(0, this.tabsLength);
    },
    otherTabs: function() {
      return this.allowedTabs.slice(this.tabsLength);
    }
  },
  created() {
    this.$store.commit("clearLead");
    this.getLead();
    this.loadStatuses();
  }
};
</script>

<style lang="scss">
.lead_detail {
  .toolbar_lead {
    // margin-top: -12px;
    // margin-left: -12px;
    // margin-right: -12px;
  }
}</style
>'
